import React from 'react';
import PropTypes from 'prop-types';

export default function Page({
  children,
  headerChildren,
  headerCustomClass,
  shouldUseInnerWrapp = true
}) {
  return (
    <div
      className="sdp-content-area"
      style={{
        overflow: shouldUseInnerWrapp ? 'auto' : 'hidden'
      }}
    >
      <header className={'sdp-page-header ' + headerCustomClass}>
        {headerChildren}
      </header>
      {shouldUseInnerWrapp ? (
        <div className="sdp-inner-wrapper">{children}</div>
      ) : (
        <>{children}</>
      )}
    </div>
  );
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
  headerChildren: PropTypes.node.isRequired,
  headerCustomClass: PropTypes.string
};
